export const membershipBlockWarningMessage = (user = {}) => {
    const memberships = user.active_memberships || [];
    const schedules = user.upcoming_paid_schedules || [];
    if (memberships.length === 0 && schedules.length === 0) return null;

    const membershipLines = memberships.map(
        (membership) => `- '${membership.gathering_name}' 멤버십 (${membership.start_date}~${membership.end_date})`,
    );
    const scheduleLines = schedules.map(
        (schedule) => `- ${schedule.title} / ${schedule.pay_type === 1 ? '무통장 입금' : '카드·기타'} (${schedule.start_date} ${schedule.start_time})`,
    );

    return [
        '차단 전에 확인이 필요해요',
        `이 회원은 예정 일정 ${schedules.length}건과 아래 결제를 보유하고 있어요.`,
        ...membershipLines,
        ...scheduleLines,
        '',
        '그래도 차단할까요?',
    ].join('\n');
};

export const resolveMembershipBlockSelection = (user = {}, confirmWarning) => {
    const warning = membershipBlockWarningMessage(user);
    if (warning && !confirmWarning(warning)) return null;

    return {
        ...user,
        blocked_yn: 1,
        membership_block_warning_confirmed: true,
    };
};
